import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type {
  UserPermissionsFetchResult,
  PermissionsState,
} from "../api/permissions/permissions.types";
import {
  DEFAULT_PERMISSIONS,
  INITIAL_PERMISSIONS_STATE,
} from "../api/permissions/permissions.types";

export const permissionsInitialState: PermissionsState =
  INITIAL_PERMISSIONS_STATE;

export const permissionsSlice = createSlice({
  name: "permissions",
  initialState: permissionsInitialState,
  reducers: {
    setPermissionsLoading: (state) => {
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    },

    setPermissions: (
      state,
      action: PayloadAction<UserPermissionsFetchResult>
    ) => {
      return {
        ...state,
        permissions: action.payload.permissions,
        isLoaded: true,
        isLoading: false,
        error: null,
        teamId: action.payload.teamId,
      };
    },

    updateSinglePermission: (
      state,
      action: PayloadAction<{ key: string; value: boolean }>
    ) => {
      return {
        ...state,
        permissions: {
          ...state.permissions,
          [action.payload.key]: action.payload.value,
        },
      };
    },

    setPermissionsError: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    },

    setPermissionsTeamId: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        teamId: action.payload,
      };
    },

    setPreferredTeamId: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        preferredTeamId: action.payload,
      };
    },

    resetPermissions: () => {
      return {
        permissions: DEFAULT_PERMISSIONS,
        teamId: null,
        preferredTeamId: null,
        isLoaded: false,
        isLoading: false,
        error: null,
      };
    },
  },
});

export const {
  setPermissionsLoading,
  setPermissions,
  updateSinglePermission,
  setPermissionsError,
  setPermissionsTeamId,
  setPreferredTeamId,
  resetPermissions,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
